import React, { useRef, useEffect, useState } from "react";
import TimelessCharmHome from "../../components/TimelessCharmHome/TimelessCharmHome";
import TimelessCharmCoupleSection from "../../components/TimelessCharmCoupleSection/TimelessCharmCoupleSection";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import VenueSection from "../../components/VenueSection/VenueSection";
import InviteeSection from "../../components/InviteeSection/InviteeSection";
import EventSection4 from "../../components/EventSection4/EventSection4";
import QuoteSection from "../../components/QuoteSection/QuoteSection";
import BottomSection from "../../components/BottomContainer/BottomContainer";
import RsvpSectionS2 from "../../components/RsvpSectionS2/RsvpSectionS2";
import LetterEnvelope from "../../components/LetterEnvelope/LetterEnvelope";

const TimelessCharm = () => {
  const containerRef = useRef();

  return (
    <div ref={containerRef} className={`fadeInSlow scroll-container`}>
      <TimelessCharmHome />
      <TimelessCharmCoupleSection />
      <LetterEnvelope />
      <QuoteSection />
      <EventSection4 haveBackground={true} />
      <VenueSection />
      <RsvpSectionS2 />
      <InviteeSection haveBackground={true} rClass="greenBG" />
      <BottomSection />
      <Footer footerClass={"wpo-site-footer-s2"} />
      <Scrollbar />
    </div>
  );
};

export default TimelessCharm;
